module.exports = __webpack_public_path__ + "img/bg_selection1.8a112324.png";